import '@polymer/iron-icon/iron-icon.js';
import '@polymer/iron-iconset-svg/iron-iconset-svg.js';
import './sigma-icons.js';
import './charter-icons.js';
import { PolymerElement, html } from '@polymer/polymer/polymer-element.js';
import { KatapultModel } from '../../modules/katapult-model/KatapultModel.js';
import { RegisterCustomIcons, CUSTOM_ICON_SET_NAME } from '../../modules/GeoStyleToIcon.js';

export function registerCustomIconSet(icons) {
  // Register the icons for map style lookups.
  RegisterCustomIcons(icons);

  let iconSet = document.querySelector(`iron-iconset-svg[name="${CUSTOM_ICON_SET_NAME}"]`);
  if (iconSet) iconSet.parentElement.removeChild(iconSet);
  if (!icons) return;

  // Create a fresh iconset so custom icon updates replace any stale definitions.
  let $_documentContainer = document.createElement('template');
  $_documentContainer.innerHTML = `
            <iron-iconset-svg name="${CUSTOM_ICON_SET_NAME}" size="24"><svg><defs>
                ${Object.values(icons)
                  .map((x) => x.svg)
                  .join('')}
            </defs></svg></iron-iconset-svg>`;

  document.head.appendChild($_documentContainer.content);
}

class KatapultMapIcons extends PolymerElement {
  static get template() {
    return html` <iron-iconset-svg name="katapult-map" size="24">
        <svg>
          <defs>
            <g id="asterisk">
              <path d="M10.5 0h3v24h-3Z"></path>
              <path d="M0 7l1.5-2.598L24 17l-1.5 2.598Z"></path>
              <path d="M0 17l1.5 2.598L24 7l-1.5-2.598Z"></path>
            </g>
            <g id="bullseye">
              <circle r="12" cy="12" cx="12" fill="#000"></circle>
              <circle r="8" cy="12" cx="12"></circle>
              <circle r="3" cy="12" cx="12" fill="#000"></circle>
            </g>
            <!-- This is the old triangle-up icon. The new one is equilateral to make aligning it easier-->
            <!--<g id="triangle-up"><polygon points="0 24, 24 24, 12 3.215" fill="#000"/><polygon points="3.25 22.5, 20.75 22.5, 12 5.5"/></g>-->
            <g id="triangle-up">
              <polygon points="12 0, 22.392 18, 1.608 18" fill="#000"></polygon>
              <polygon points="12 1.625, 19.985 16.688, 4.045 16.688"></polygon>
            </g>
            <!-- This is the old triangle-down icon. The new one is equilateral to make aligning it easier-->
            <!--<g id="triangle-down"><polygon points="0 0, 24 0, 12, 24"/></g>-->
            <g id="triangle-down"><polygon points="1.608 6, 22.392 6, 12 24"></polygon></g>
            <g id="square"><rect x="0" y="0" width="24" height="24"></rect></g>
            <g id="square-thin-stroke"><rect x="0" y="0" width="24" height="24" stroke="#000" stroke-width="5"></rect></g>
            <g id="square-thick-stroke"><rect x="0" y="0" width="24" height="24" stroke="#000" stroke-width="10"></rect></g>
            <g id="circle"><circle r="10.5" cy="12" cx="12" stroke="#000" stroke-width="3"></circle></g>
            <g id="circle-black"><circle r="10.5" cy="12" cx="12" stroke="#000" fill="#000" stroke-width="3"></circle></g>
            <g id="circle-with-x">
              <circle r="10.5" cy="12" cx="12" stroke="#000" fill="#fff" stroke-width="3"></circle>
              <line x1="4" y1="4" x2="20" y2="20" style="stroke:#000; stroke-width:3"></line>
              <line x1="4" y1="20" x2="20" y2="4" style="stroke:#000; stroke-width:3"></line>
            </g>
            <g id="circle-with-triangle" stroke="#000" fill="#fff" stroke-width="3">
              <circle r="10.5" cy="12" cx="12"></circle>
              <path d="m12 4 l-6 12 l12 0 l-6 -12z"></path>
            </g>
            <g id="half-circle-vertical-black-left">
              <circle r="10.5" cy="12" cx="12" stroke="#000" fill="#000" stroke-width="3"></circle>
              <path d="M12,3 a1,1 0 0 0 0,18" fill="#fff"></path>
            </g>
            <g id="half-circle-vertical-left-thin-stroke">
              <circle r="10.5" cy="12" cx="12" stroke="#000" stroke-width="1" />
              <path d="M12,3 a1,1 0 0 0 0,18" fill="#fff" />
            </g>
            <g id="circle-light-stroke"><circle r="10.5" cy="12" cx="12" stroke="#000" stroke-width="1"></circle></g>
            <g id="circle-small"><circle r="9.5" cy="12" cx="12" stroke="#000" stroke-width="5"></circle></g>
            <g id="ring"><circle r="10" cy="12" cx="12" fill="none"></circle></g>
            <g id="hexagon">
              <polygon points="12 0, 22.392 6, 22.392 18, 12 24, 1.608 18, 1.608 6" fill="black"></polygon>
              <polygon points="12 3.5, 19.361 7.75, 19.361 16.25, 12 20.5, 4.639 16.25, 4.639 7.75"></polygon>
            </g>
            <g id="multiply">
              <path d="M0 2.828l2.828-2.828L24 21.172l-2.828 2.828Z"></path>
              <path d="M0 21.172l2.828 2.828L24 2.828l-2.828-2.828Z"></path>
            </g>
            <g id="gps">
              <path
                d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
              ></path>
            </g>
            <g id="rubberband">
              <g>
                <path
                  d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                ></path>
                <circle cx="12" cy="23" r="1"></circle>
              </g>
            </g>
            <g id="cursor">
              <g><path d="M4 0l16 12.279-6.78 1.138 4.256 8.676-3.902 1.907-4.281-8.758-5.293 4.581z"></path></g>
            </g>
            <g id="pin">
              <g><path d="M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12M8.8,14L10,12.8V4H14V12.8L15.2,14H8.8Z"></path></g>
            </g>
            <g id="halo">
              <defs>
                <filter id="blur"><feGaussianBlur in="SourceGraphic" stdDeviation="3"></feGaussianBlur></filter>
              </defs>
              <circle r="10.5" cx="12" cy="12" filter="url(#blur)"></circle>
            </g>
          </defs>
        </svg> </iron-iconset-svg
      ><iron-iconset-svg name="map-prints" size="24">
        <svg>
          <defs>
            <g id="rounded-rectangle">
              <rect x="1.5" y="1.5" width="21" height="21" stroke-width="3" rx="3"></rect>
            </g>
            <g id="triangle"><path stroke-width="3" d="m2.650422,20.18088l9.349578,-16.361761l9.349578,16.361761l-18.699156,0z"></path></g>
            <g id="circle"><circle r="10.5" cy="12" cx="12" stroke-width="3"></circle></g>
            <g id="hexagon">
              <path
                stroke-width="3"
                d="m1.693561,12l4.417046,-8.834091l11.778788,0l4.417044,8.834091l-4.417044,8.834091l-11.778788,0l-4.417046,-8.834091z"
              ></path>
            </g>
            <g id="octagon">
              <path
                stroke-width="3"
                d="m1.571764,7.680451l6.108688,-6.108687l8.639096,0l6.108688,6.108687l0,8.639097l-6.108688,6.108688l-8.639096,0l-6.108688,-6.108688l0,-8.639097z"
              ></path>
            </g>
          </defs>
        </svg> </iron-iconset-svg
      ><iron-iconset-svg name="ppl-equipment-icons" size="24">
        <svg>
          <defs>
            <g id="Transformer">
              <path stroke-width="3" d="m2.650422,20.18088l9.349578,-16.361761l9.349578,16.361761l-18.699156,0z"></path>
            </g>
            <g id="Switch">
              <path d="M5.72,14.92A2.4,2.4,0,0,1,6,11.46a2.4,2.4,0,0,1,3.46.25l-1.85,1.6Z"></path>
              <line x1="5.73" y1="14.96" x2="14.82" y2="7.04"></line>
              <path d="M7.45,17.06A4.31,4.31,0,0,1,11,16.83c.15.06.22-.18.07-.24a4.48,4.48,0,0,0-3.72.26c-.14.07,0,.29.12.21Z"></path>
              <text transform="translate(12.22 10.44) rotate(90)">T</text>
            </g>
            <g id="Recloser">
              <rect
                style="fill:none;stroke:#231f20;stroke-width:0.16711949px;stroke-miterlimit:10"
                id="rect8"
                height="10.388983"
                width="10.388983"
                y="6.7746134"
                x="6.5384746"
                class="cls-1"
              ></rect>
              <polygon
                transform="matrix(0.08355974,0,0,0.08355974,-4.0744449,-2.9241654)"
                style="fill:#231f20;stroke:#231f20;stroke-width:2px;stroke-miterlimit:10"
                id="polygon10"
                points="249.69,238.75 128.56,117.62 127.5,239.59 "
                class="cls-2"
              ></polygon>
              <circle
                r="1.2467114"
                style="fill:#231f20;stroke:#231f20;stroke-width:0.16711949px;stroke-miterlimit:10"
                id="circle12"
                cy="5.5354223"
                cx="11.75177"
                class="cls-2"
              ></circle>
              <circle
                r="1.2467114"
                style="fill:#231f20;stroke:#231f20;stroke-width:0.16711949px;stroke-miterlimit:10"
                id="circle14"
                cy="18.401117"
                cx="11.75177"
                class="cls-2"
              ></circle>
              <path
                style="fill:#231f20;stroke-width:0.08355974"
                id="path16"
                d="m 12.160375,4.5561026 a 1.6536473,1.6536473 0 0 1 0.32338,-0.6734921 0.21224174,0.21224174 0 0 0 -0.0919,-0.349279 3.0256982,3.0256982 0 0 1 -1.06789,-0.524756 l -0.0426,0.334239 a 5.8149224,5.8149224 0 0 0 1.09965,-1.002717 c 0.0769,-0.09108 0.0911,-0.269062 -0.0426,-0.3275539 q -0.38354,-0.167119 -0.75203,-0.362649 c -0.041,-0.02173 -0.33424,-0.192187 -0.34009,-0.182996 -0.006,0.0092 0.008,0.05264 0.0167,0.05431 0.008,0.0017 0.0242,-0.01588 0.0276,-0.01755 a 1.2742861,1.2742861 0 0 0 0.15793,-0.08356 1.0862766,1.0862766 0 0 0 0.50136,-1.16315204 c -0.0568,-0.262378 -0.45958,-0.151243 -0.40276,0.111135 a 0.66012196,0.66012196 0 0 1 -0.12784,0.533946 c -0.14623,0.18801004 -0.4178,0.21307804 -0.53061,0.43116904 a 0.35930689,0.35930689 0 0 0 0.0518,0.417798 c 0.0953,0.09944 0.24566,0.158764 0.36599,0.223105 q 0.40443,0.2155839 0.82557,0.4002509 l -0.0426,-0.3283899 a 5.4313832,5.4313832 0 0 1 -1.01442,0.9392119 c -0.0969,0.06852 -0.15876,0.23898 -0.0426,0.328389 a 3.5646586,3.5646586 0 0 0 1.2534,0.630876 l -0.0927,-0.349279 a 2.1265954,2.1265954 0 0 0 -0.43033,0.8573231 c -0.061,0.261542 0.34176,0.372676 0.40275,0.111134 z"
                class="cls-3"
              ></path>
              <path
                style="fill:#231f20;stroke-width:0.08355974"
                id="path18"
                d="m 11.467665,19.762304 a 2.1265954,2.1265954 0 0 0 0.43033,0.857322 l 0.0927,-0.348444 a 3.5563026,3.5563026 0 0 0 -1.25339,0.630041 c -0.11531,0.09024 -0.0543,0.259871 0.0426,0.32839 a 5.4363968,5.4363968 0 0 1 1.01442,0.939211 l 0.0426,-0.327554 q -0.41111,0.180489 -0.80802,0.390224 c -0.12367,0.06601 -0.28577,0.127846 -0.38354,0.232296 a 0.36014249,0.36014249 0 0 0 -0.0518,0.417799 c 0.11197,0.216419 0.3827,0.242323 0.52893,0.428661 a 0.66095756,0.66095756 0 0 1 0.12952,0.535618 c -0.0568,0.262378 0.34593,0.374348 0.40275,0.111135 a 1.0862766,1.0862766 0 0 0 -0.50135,-1.162316 c -0.0468,-0.02674 -0.0969,-0.04679 -0.14373,-0.0727 0.0192,0.01003 -0.0376,-0.02507 -0.0401,-0.02423 -0.002,8.36e-4 -0.0226,0.0351 -0.0159,0.04763 -0.009,0.0142 -0.007,0.0142 0.008,0 0.0151,-0.01421 0.0326,-0.01922 0.0493,-0.02757 0.0167,-0.0084 0.0577,-0.03259 0.0836,-0.04847 0.0585,-0.03175 0.11699,-0.0635 0.17632,-0.09442 0.25067,-0.133695 0.51055,-0.257364 0.77209,-0.372676 0.13369,-0.05849 0.11949,-0.236474 0.0426,-0.327554 a 5.871743,5.871743 0 0 0 -1.09964,-1.002717 l 0.0426,0.32839 a 3.0256982,3.0256982 0 0 1 1.0679,-0.523084 0.21224174,0.21224174 0 0 0 0.0919,-0.34928 1.6645101,1.6645101 0 0 1 -0.32337,-0.673492 c -0.061,-0.261542 -0.46376,-0.150407 -0.40276,0.111135 z"
                class="cls-3"
              ></path>
            </g>
            <g id="Capacitor">
              <line
                style="fill:none;stroke:#231f20;stroke-width:0.1624622px;stroke-miterlimit:10"
                id="line8"
                y2="24.401009"
                x2="11.892955"
                y1="5.6366353"
                x1="11.892955"
                class="cls-1"
              ></line>
              <line
                style="fill:none;stroke:#231f20;stroke-width:0.1624622px;stroke-miterlimit:10"
                id="line10"
                y2="8.8945398"
                x2="6.1991982"
                y1="8.8945398"
                x1="17.58671"
                class="cls-1"
              ></line>
              <line
                style="fill:none;stroke:#231f20;stroke-width:0.1624622px;stroke-miterlimit:10"
                id="line12"
                y2="8.813302"
                x2="6.1991982"
                y1="14.088998"
                x1="6.1991982"
                class="cls-1"
              ></line>
              <line
                style="fill:none;stroke:#231f20;stroke-width:0.1624622px;stroke-miterlimit:10"
                id="line14"
                y2="8.8100672"
                x2="17.552057"
                y1="14.085732"
                x1="17.552057"
                class="cls-1"
              ></line>
              <circle
                style="fill:#231f20;stroke-width:0.10830814"
                id="circle16"
                r="3.9900718"
                cy="4.3910909"
                cx="15.471461"
                class="cls-2"
              ></circle>
              <text
                style="font-size:8.73071861px;font-family:HelveticaNeue, 'Helvetica Neue';fill:#ffffff;stroke-width:0.10830814"
                y="8.3811426"
                x="12.953288"
                id="text18"
                class="cls-3"
              >
                T
              </text>
            </g>
            <g id="pad-transformer" fill="#fff" stroke-width="3" stroke="#000">
              <path stroke-width="2" d="m0 0 h24 v24 h-24 v -24z" />
              <path fill="none" d="m0 0 l12 23 l12 -23z" />
            </g>
          </defs>
        </svg> </iron-iconset-svg
      ><iron-iconset-svg name="katapult-misc" size="24">
        <svg>
          <defs>
            <g id="business-add">
              <path
                xmlns="http://www.w3.org/2000/svg"
                transform="translate(-296.48 -598.29)"
                d="m292.21 605.84v3h-3v2h3v3h2v-3h3v-2h-3v-3zm6.2687-4.5547v18h20v-14h-10v-4zm2 2h2v2h-2zm4 0h2v2h-2zm-4 4h2v2h-2zm4 0h2v2h-2zm4 0h8v10h-8v-2h2v-2h-2v-2h2v-2h-2zm4 2v2h2v-2zm-12 2h2v2h-2zm4 0h2v2h-2zm8 2v2h2v-2zm-12 2h2v2h-2zm4 0h2v2h-2z"
              />
            </g>
            <g id="drag-indicator">
              <path fill="none" d="M0 0h24v24H0V0z" />
              <path
                d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
              />
            </g>
            <g id="construction">
              <rect height="8.48" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -6.8717 17.6255)" width="3" x="16.34" y="12.87" />
              <path
                d="M17.5,10c1.93,0,3.5-1.57,3.5-3.5c0-0.58-0.16-1.12-0.41-1.6l-2.7,2.7L16.4,6.11l2.7-2.7C18.62,3.16,18.08,3,17.5,3 C15.57,3,14,4.57,14,6.5c0,0.41,0.08,0.8,0.21,1.16l-1.85,1.85l-1.78-1.78l0.71-0.71L9.88,5.61L12,3.49 c-1.17-1.17-3.07-1.17-4.24,0L4.22,7.03l1.41,1.41H2.81L2.1,9.15l3.54,3.54l0.71-0.71V9.15l1.41,1.41l0.71-0.71l1.78,1.78 l-7.41,7.41l2.12,2.12L16.34,9.79C16.7,9.92,17.09,10,17.5,10z"
              />
            </g>
            <g id="filter-alt">
              <path d="M0,0h24 M24,24H0" fill="none" />
              <path
                d="M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6c0,0,3.72-4.8,5.74-7.39 C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z"
              />
              <path d="M0,0h24v24H0V0z" fill="none" />
            </g>
            <g id="search-off">
              <g><rect fill="none" height="24" width="24" /></g>
              <g>
                <g>
                  <path
                    d="M15.5,14h-0.79l-0.28-0.27C15.41,12.59,16,11.11,16,9.5C16,5.91,13.09,3,9.5,3C6.08,3,3.28,5.64,3.03,9h2.02 C5.3,6.75,7.18,5,9.5,5C11.99,5,14,7.01,14,9.5S11.99,14,9.5,14c-0.17,0-0.33-0.03-0.5-0.05v2.02C9.17,15.99,9.33,16,9.5,16 c1.61,0,3.09-0.59,4.23-1.57L14,14.71v0.79l5,4.99L20.49,19L15.5,14z"
                  />
                  <polygon
                    points="6.47,10.82 4,13.29 1.53,10.82 0.82,11.53 3.29,14 0.82,16.47 1.53,17.18 4,14.71 6.47,17.18 7.18,16.47 4.71,14 7.18,11.53"
                  />
                </g>
              </g>
            </g>
            <g id="preview">
              <rect fill="none" height="24" width="24" />
              <path
                d="M19,3H5C3.89,3,3,3.9,3,5v14c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.11,3,19,3z M19,19H5V7h14V19z M13.5,13 c0,0.83-0.67,1.5-1.5,1.5s-1.5-0.67-1.5-1.5c0-0.83,0.67-1.5,1.5-1.5S13.5,12.17,13.5,13z M12,9c-2.73,0-5.06,1.66-6,4 c0.94,2.34,3.27,4,6,4s5.06-1.66,6-4C17.06,10.66,14.73,9,12,9z M12,15.5c-1.38,0-2.5-1.12-2.5-2.5c0-1.38,1.12-2.5,2.5-2.5 c1.38,0,2.5,1.12,2.5,2.5C14.5,14.38,13.38,15.5,12,15.5z"
              />
            </g>
            <g id="engineering">
              <path d="M9,15c-2.67,0-8,1.34-8,4v2h16v-2C17,16.34,11.67,15,9,15z" />
              <path
                d="M22.1,6.84c0.01-0.11,0.02-0.22,0.02-0.34c0-0.12-0.01-0.23-0.03-0.34l0.74-0.58c0.07-0.05,0.08-0.15,0.04-0.22l-0.7-1.21 c-0.04-0.08-0.14-0.1-0.21-0.08L21.1,4.42c-0.18-0.14-0.38-0.25-0.59-0.34l-0.13-0.93C20.36,3.06,20.29,3,20.2,3h-1.4 c-0.09,0-0.16,0.06-0.17,0.15L18.5,4.08c-0.21,0.09-0.41,0.21-0.59,0.34l-0.87-0.35c-0.08-0.03-0.17,0-0.21,0.08l-0.7,1.21 c-0.04,0.08-0.03,0.17,0.04,0.22l0.74,0.58c-0.02,0.11-0.03,0.23-0.03,0.34c0,0.11,0.01,0.23,0.03,0.34l-0.74,0.58 c-0.07,0.05-0.08,0.15-0.04,0.22l0.7,1.21c0.04,0.08,0.14,0.1,0.21,0.08l0.87-0.35c0.18,0.14,0.38,0.25,0.59,0.34l0.13,0.93 C18.64,9.94,18.71,10,18.8,10h1.4c0.09,0,0.16-0.06,0.17-0.15l0.13-0.93c0.21-0.09,0.41-0.21,0.59-0.34l0.87,0.35 c0.08,0.03,0.17,0,0.21-0.08l0.7-1.21c0.04-0.08,0.03-0.17-0.04-0.22L22.1,6.84z M19.5,7.75c-0.69,0-1.25-0.56-1.25-1.25 s0.56-1.25,1.25-1.25s1.25,0.56,1.25,1.25S20.19,7.75,19.5,7.75z"
              />
              <path
                d="M19.92,11.68l-0.5-0.87c-0.03-0.06-0.1-0.08-0.15-0.06l-0.62,0.25c-0.13-0.1-0.27-0.18-0.42-0.24l-0.09-0.66 C18.12,10.04,18.06,10,18,10h-1c-0.06,0-0.11,0.04-0.12,0.11l-0.09,0.66c-0.15,0.06-0.29,0.15-0.42,0.24l-0.62-0.25 c-0.06-0.02-0.12,0-0.15,0.06l-0.5,0.87c-0.03,0.06-0.02,0.12,0.03,0.16l0.53,0.41c-0.01,0.08-0.02,0.16-0.02,0.24 c0,0.08,0.01,0.17,0.02,0.24l-0.53,0.41c-0.05,0.04-0.06,0.11-0.03,0.16l0.5,0.87c0.03,0.06,0.1,0.08,0.15,0.06l0.62-0.25 c0.13,0.1,0.27,0.18,0.42,0.24l0.09,0.66C16.89,14.96,16.94,15,17,15h1c0.06,0,0.12-0.04,0.12-0.11l0.09-0.66 c0.15-0.06,0.29-0.15,0.42-0.24l0.62,0.25c0.06,0.02,0.12,0,0.15-0.06l0.5-0.87c0.03-0.06,0.02-0.12-0.03-0.16l-0.52-0.41 c0.01-0.08,0.02-0.16,0.02-0.24c0-0.08-0.01-0.17-0.02-0.24l0.53-0.41C19.93,11.81,19.94,11.74,19.92,11.68z M17.5,13.33 c-0.46,0-0.83-0.38-0.83-0.83c0-0.46,0.38-0.83,0.83-0.83s0.83,0.38,0.83,0.83C18.33,12.96,17.96,13.33,17.5,13.33z"
              />
              <path
                d="M4.74,9h8.53c0.27,0,0.49-0.22,0.49-0.49V8.49c0-0.27-0.22-0.49-0.49-0.49H13c0-1.48-0.81-2.75-2-3.45V5.5 C11,5.78,10.78,6,10.5,6S10,5.78,10,5.5V4.14C9.68,4.06,9.35,4,9,4S8.32,4.06,8,4.14V5.5C8,5.78,7.78,6,7.5,6S7,5.78,7,5.5V4.55 C5.81,5.25,5,6.52,5,8H4.74C4.47,8,4.25,8.22,4.25,8.49v0.03C4.25,8.78,4.47,9,4.74,9z"
              />
              <path d="M9,13c1.86,0,3.41-1.28,3.86-3H5.14C5.59,11.72,7.14,13,9,13z" />
            </g>
          </defs>
        </svg>
      </iron-iconset-svg>`;
  }

  static get is() {
    return 'katapult-map-icons';
  }
  static get properties() {
    return {};
  }
  static get observers() {
    return ['loadCustomIcons(modelKey)'];
  }
  ready() {
    super.ready();
  }

  async loadCustomIcons() {
    if (this.modelKey) {
      // Remove the existing listener
      this._unsubscribeCustomIcons?.();
      // Set up a listener for custom icons changes
      this._unsubscribeCustomIcons = KatapultModel.fromId(this.modelKey).onCustomIconsSnapshot((snapshot) => {
        registerCustomIconSet(snapshot.val());
      });
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this._unsubscribeCustomIcons?.();
  }
}
window.customElements.define(KatapultMapIcons.is, KatapultMapIcons);
